<template>
  <div class="h-full px-4 pb-10">
    <div v-if="loaded && dataAvailable" class="flex flex-row h-full pb-5 mt-6 -ml-3 ">

      <div class="flex flex-col mb-14 ml-2 justify-around w-6 ">
        <div class=" self-center" v-for="(item, index) in countries" :key="index">
          <img class="" width="24" height="18" :title="regionName.of(item.value.toUpperCase())" :src="countryFlags[index]" :alt="item.value">
        </div>
      </div>

      <bar-chart class="mr-24 pr-2 mb-7 z-10 " :source="source" :style="style" :colorPalette="colorPalette" :labels="countryNames" :values="countryVisits" :subject="subject"></bar-chart>

      <div class="flex flex-col mb-14 -ml-28 w-20 justify-around ">
        <div v-for="item in countries" :key="item.id">
          <percentage-item :percentage="item.percentage/100"></percentage-item>

        </div>
      </div>

    </div>
    <div v-if="! dataAvailable" class="h-full flex justify-center">
        <p class="self-center mt-10 text-center">{{ $t('widget.noData') }}</p>
    </div>
  </div>
</template>

<script setup>
import {defineEmits, defineProps, onMounted, ref, watch} from "vue";
import BarChart from "@/widgetContent/charts/BarChart";
import PercentageItem from "@/widgetContent/extras/PercentageItem.vue";
import ApiService from "@/services/ApiService";
let apiService = new ApiService;
import {useApiStore} from "@/stores/ApiStore";
const emit = defineEmits(["dataLoaded", "dataUnloaded"])

const apiDataStore = useApiStore();
let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})
let countries = ref(Object);
let countryNames = ref([]);
let countryVisits = ref([]);
let countryPercentage = ref([]);
let loaded = ref(false);
let countryFlags = ref([]);
let dataAvailable = ref(true);
let subject = ref("")
onMounted ( async () => {
      await getData(props.source);
    }
)

const regionName = new Intl.DisplayNames(
    [apiDataStore.getLang], { type: 'region'}
);


async function getData(url){
  countryNames.value = [];
  countryVisits.value = [];
  countryPercentage.value = [];
  countryFlags.value = [];
  let apiData = await apiService.get(url)
  emit("dataLoaded")
  countries.value = apiData.data;
  subject.value = apiData.subject;
  if (countries.value.length > 0){
    dataAvailable.value = true;
    countries.value.forEach(country => {
      countryNames.value.push(regionName.of(country.value.toUpperCase()));
      countryVisits.value.push(country.amount);
      countryPercentage.value.push(country.percentage);
      countryFlags.value.push("../countryFlags/" + country.value + ".svg");
      loaded.value = true;
    })
  } else {
    dataAvailable.value = false;
  }

}

watch(() => props.update, async () => {
  loaded.value = false;
  emit("dataUnloaded")
  dataAvailable.value = false;
  await getData(props.source);
})


</script>
